__turbopack_context__.v({
  "avatar": "ContactSection-module-scss-module__ycANiG__avatar",
  "calendlyButton": "ContactSection-module-scss-module__ycANiG__calendlyButton",
  "calendlyCard": "ContactSection-module-scss-module__ycANiG__calendlyCard",
  "calendlyInfo": "ContactSection-module-scss-module__ycANiG__calendlyInfo",
  "calendlySection": "ContactSection-module-scss-module__ycANiG__calendlySection",
  "container": "ContactSection-module-scss-module__ycANiG__container",
  "ellipse": "ContactSection-module-scss-module__ycANiG__ellipse",
  "fade-in": "ContactSection-module-scss-module__ycANiG__fade-in",
  "form": "ContactSection-module-scss-module__ycANiG__form",
  "formWrapper": "ContactSection-module-scss-module__ycANiG__formWrapper",
  "iconWrapper": "ContactSection-module-scss-module__ycANiG__iconWrapper",
  "privacyLink": "ContactSection-module-scss-module__ycANiG__privacyLink",
  "profileLink": "ContactSection-module-scss-module__ycANiG__profileLink",
  "successBox": "ContactSection-module-scss-module__ycANiG__successBox",
});
